/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MainLayoutRouteImport } from './routes/_main-layout'
import { Route as MainLayoutIndexRouteImport } from './routes/_main-layout/index'
import { Route as MainLayoutRolesRouteImport } from './routes/_main-layout/roles'
import { Route as MainLayoutUsersRouteImport } from './routes/_main-layout/users'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'

const MainLayoutRoute = MainLayoutRouteImport.update({
  id: '/_main-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const MainLayoutIndexRoute = MainLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainLayoutRoute,
} as any)
const MainLayoutRolesRoute = MainLayoutRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => MainLayoutRoute,
} as any)
const MainLayoutUsersRoute = MainLayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => MainLayoutRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof MainLayoutIndexRoute
  '/roles': typeof MainLayoutRolesRoute
  '/users': typeof MainLayoutUsersRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
}
export interface FileRoutesByTo {
  '/roles': typeof MainLayoutRolesRoute
  '/users': typeof MainLayoutUsersRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/': typeof MainLayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_main-layout': typeof MainLayoutRouteWithChildren
  '/_main-layout/roles': typeof MainLayoutRolesRoute
  '/_main-layout/users': typeof MainLayoutUsersRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/_main-layout/': typeof MainLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/roles' | '/users' | '/auth/login' | '/auth/reset-password'
  fileRoutesByTo: FileRoutesByTo
  to: '/roles' | '/users' | '/auth/login' | '/auth/reset-password' | '/'
  id:
    | '__root__'
    | '/_main-layout'
    | '/_main-layout/roles'
    | '/_main-layout/users'
    | '/auth/login'
    | '/auth/reset-password'
    | '/_main-layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MainLayoutRoute: typeof MainLayoutRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_main-layout': {
      id: '/_main-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main-layout/': {
      id: '/_main-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainLayoutIndexRouteImport
      parentRoute: typeof MainLayoutRoute
    }
    '/_main-layout/roles': {
      id: '/_main-layout/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof MainLayoutRolesRouteImport
      parentRoute: typeof MainLayoutRoute
    }
    '/_main-layout/users': {
      id: '/_main-layout/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof MainLayoutUsersRouteImport
      parentRoute: typeof MainLayoutRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface MainLayoutRouteChildren {
  MainLayoutRolesRoute: typeof MainLayoutRolesRoute
  MainLayoutUsersRoute: typeof MainLayoutUsersRoute
  MainLayoutIndexRoute: typeof MainLayoutIndexRoute
}

const MainLayoutRouteChildren: MainLayoutRouteChildren = {
  MainLayoutRolesRoute: MainLayoutRolesRoute,
  MainLayoutUsersRoute: MainLayoutUsersRoute,
  MainLayoutIndexRoute: MainLayoutIndexRoute,
}

const MainLayoutRouteWithChildren = MainLayoutRoute._addFileChildren(
  MainLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  MainLayoutRoute: MainLayoutRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
